const CALL_TYPES = {
  BASIC: 'Basic',
  PREMIUM: 'Premium'
};

export default CALL_TYPES;